import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiConfig } from '../Config/api.config';
@Injectable({
  providedIn: 'root'
})
export class TransactionService {

  constructor(private http: HttpClient) {}

  getTransactionHistory(userSession: string): Observable<any> {
    const headers = new HttpHeaders({
      'X-Api-Key': ApiConfig.apiKey,
      'Authorization': `Bearer ${userSession}`
    });

    return this.http.get(
      `${ApiConfig.baseUrl}/transaction/transaction-history`,
      { headers }
    );
  }
}